import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import clsx from 'clsx';
import { withRouter } from 'react-router-dom';
import "../Styles/react-datepicker.css";
import Moment from 'moment'
import Loader from 'react-loader-spinner';
import DatePicker from "react-datepicker";
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import DemoForm from './DemoForm';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import momentTimezone from 'moment-timezone';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import SyncAltIcon from '@material-ui/icons/SyncAlt';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ExpandMoreSharpIcon from '@material-ui/icons/ExpandMoreSharp';
import InputAdornment from '@material-ui/core/InputAdornment';

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.dullGray,
        color: theme.palette.white,
        boxShadow: theme.shadows[1],
        fontSize: '13px',
    },
    arrow: {
        color: theme.palette.dullGray,
    }
}))(Tooltip);
const fields = [
    {
        name: 'name',
        label: 'Name*',
        required: true,
    },
    {
        name: 'phone',
        label: 'Phone Number*',
        required: true,
    }
]
@inject('commonStore') @observer
@observer
class Scheduler extends Component {
    state = {
        showForm: false,
        selectedDate: new Date(), includeTimes: [new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 20, 0, 0)],
        duration: 'thirtyMin',
        timezone: momentTimezone.tz.guess(),
        divHeight: '100%',
        timeSelected: false,
        showTimezones: false
    }

    onTimezoneClick = () => {
        this.setState({showTimezones: true})
     
    }

    closeTimezone = () =>{
        this.setState({showTimezones: false})
       
    }

    componentDidMount() {

        if (this.props.location.state && this.props.location.state.duration)
            this.setState({ duration: this.props.location.state.duration })
        var date = new Date();
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        this.props.commonStore.showFreeSlots(Moment(new Date()).format('MMMM'), momentTimezone.tz.guess())
            .then(() => {
                let currentDate = new Date()
                if (!this.props.commonStore.inProgress)
                    this.selectDate(new Date(), this.state.duration)
            })
        let elem = document.getElementById('scheduler-datePickerDiv')
        if (elem)
            this.setState({ divHeight: elem.clientHeight.toString() + 'px' })
    }

    onMonthChange = (date) => {
        // var first = Moment().startOf(date.getMonth());
        var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

        this.props.commonStore.showFreeSlots(Moment(firstDay).format('MMMM'), this.state.timezone)
            .then(() => {
                this.selectDate(firstDay, this.state.duration)
            })
    }

    isDayEnabled = date => {
        const { freeSlotsData } = this.props.commonStore;
        const { duration } = this.state
        const day = date.getDay();
        if (day == 0 || day == 6)
            return false
        let ind = -1
        if (freeSlotsData && freeSlotsData[`${duration}`]) {
            ind = freeSlotsData[`${duration}`].findIndex(x => Moment(date).format('YYYY-MM-DD') == x.date)
            if (ind > -1) {
                if (freeSlotsData[`${duration}`][ind].status && freeSlotsData[`${duration}`][ind].freeSlots.length > 0) {
                    return true
                }

            }
            return false
        }
        return false
    };

    filterPassedTime = time => {
        const selectedDate = new Date(time);
        let a = momentTimezone(new Date()).tz(this.state.timezone).format('YYYYMMDD HH:mm z')
        let t = a.split(" ")[1] && a.split(" ")[1].split(":")[0]
        let mins = a.split(" ")[1] && a.split(" ")[1].split(":")[1]
        let newDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), t, mins, 0)
        return newDate.getTime() < selectedDate.getTime()
    }

    selectDate = (date, duration) => {
        const { freeSlotsData } = this.props.commonStore;
        this.setState({ selectedDate: date, timeSelected: false })
        let ind = -1
        ind = freeSlotsData[`${duration}`].findIndex(x => Moment(date).format('YYYY-MM-DD') == x.date)
        if (ind > -1) {
            let temp = []
            freeSlotsData[`${duration}`][ind].freeSlots.map((row, index) => {
                let time = new Date(row.replace(/-/g, "/")).getHours()
                let mins = new Date(row.replace(/-/g, "/")).getMinutes()
                temp.push(new Date(date.getFullYear(), date.getMonth(), date.getDate(), time, mins, 0))
            })
            this.setState({ includeTimes: temp })
        }
    }

    selectTime = (time) => {
        this.setState({ selectedDate: time, timeSelected: true })
    }

    goBack = () => {
        this.setState({ showForm: false })
    }

    onTimezoneChange = (v) => {
        if (v !== null) {
            this.setState({ timezone: v, timeSelected: false })
            this.props.commonStore.showFreeSlots(Moment(new Date()).format('MMMM'), v)
                .then(() => {
                    this.selectDate(this.state.selectedDate, this.state.duration)
                })
        }

    }

    setDuration = (v) => {
        this.setState({ duration: v, timeSelected: false })
        this.selectDate(this.state.selectedDate, v)
    }

    confirm = () => {
        if (this.state.timeSelected)
            this.props.history.push({
                pathname: `/form/${this.state.selectedDate.toString()}/${this.state.duration}/${encodeURIComponent(this.state.timezone)}`,
            })
        else
            this.props.commonStore.handleOpenSnackBar('Please select a time slot before proceeding', 'error')

    }

    getLastDate = () => {
        var lastDay = new Date(new Date().getFullYear(), new Date().getMonth() + 3, 0);
        return lastDay
    }

    render() {
        const { showForm, selectedDate, includeTimes, duration, timezone, divHeight, timeSelected , showTimezones} = this.state;
        const { inProgress } = this.props.commonStore
        return (
            showForm ? <DemoForm selectedDate={selectedDate} goBack={this.goBack} duration={duration} /> :
                <div className='sc-container'>
                    <div className='rowFlex' style={{ justifyContent: 'space-between' }}>
                        <div className='subHeading1 bold rowFlex'>
                            <div className='vertCenter'>{duration === 'thirtyMin' ? '30 Minute Call' : '60 Minute Call'}&nbsp;&nbsp;</div>
                            <div className='vertCenter desc syncIcon' onClick={(e) => this.setDuration(duration === 'thirtyMin' ? 'sixtyMin' : 'thirtyMin')}><SyncAltIcon className='vertCenter desc' /></div>&nbsp;&nbsp;
                <div className='vertCenter desc syncIcon' onClick={(e) => this.setDuration(duration === 'thirtyMin' ? 'sixtyMin' : 'thirtyMin')}>{duration === 'thirtyMin' ? '60 Minute Call' : '30 Minute Call'}</div>
                        </div>
                        <div onClick={(e) => this.confirm()} className='buttonText confirmButton formButtonContainer vertCenter'>CONFIRM</div>
                    </div>
                    <div className='s-desc rowFlex' ><div>Timezone:</div>
               
                        <div className={'s-desc timezone'} id='timezone' >
                            
                            <ClickAwayListener onClickAway={this.closeTimezone}>
                            <Autocomplete style={{ position: 'absolute', top: '0'}}
                                disableClearable 
                                className="combo-box-demo"
                                options={momentTimezone.tz.names()}
                                getOptionLabel={(option) => option}
                                renderOption={(option) => (
                                    <div className='desc timezoneList'>
                                        <span>{option}</span> &nbsp;&nbsp;
                                        { "GMT" + momentTimezone.tz(option).format('Z') + " hrs"}
                                    </div>
                                )}
                                classes={{ popper: 'ppopper' }}
                                onChange={(e, v) => this.onTimezoneChange(v)}
                                value={timezone}
                                groupBy={(option) => option.firstLetter}
                                renderInput={(params) => <TextField {...params} className='timezone'  InputProps={{
                                    ...params.InputProps,
                                    disableUnderline: true,
                                    classes: { input: 'timezone', },
                                    

                                }}

                                />}
                            />
                            </ClickAwayListener>
                           
                        </div>

                    </div>
                    {

                        <div className={' calendarForm'}>

                            <div className='dateForm'>
                                <div className='calendarContainer fullWidth'  >

                                    <div id='scheduler-datePickerDiv'>
                                        <div className='rowFlex'>
                                            <div className='vertCenter'> <CheckCircleIcon className='desc dateSelected ' /></div>&nbsp;&nbsp;
                            <div className='desc vertCenter semiBold'>Select a Date</div></div>
                                        <br />
                                        <div className='rowFlex'>
                                            <DatePicker
                                                selected={selectedDate}
                                                onChange={date => this.selectDate(date, duration)}
                                                onMonthChange={(date) => this.onMonthChange(date)}
                                                minDate={new Date()}
                                                filterDate={this.isDayEnabled}
                                                maxDate={this.getLastDate()}
                                                placeholderText="Select a weekday"
                                                dateFormat="MMMM d, yyyy h:mm aa"
                                                inline
                                            />
                                        </div>
                                    </div>



                                    <div className='timePickerContainer' >
                                        <div className='rowFlex'>
                                            <div className='vertCenter'> <CheckCircleIcon className={clsx({ 'desc checkIcon': true, 'dateSelected': timeSelected })} /></div>&nbsp;&nbsp;
                            <div className='desc vertCenter semiBold'>Select a time</div></div>
                                        <br />
                                        <div class="react-datepicker__header react-datepicker__header--has-time-select"></div>
                                        {
                                            inProgress ?
                                                <div className='loadingContainer'><div className='loading'><Loader height={30} width={30} color={'black'} type="ThreeDots" timeout={100000} /></div></div>
                                                :
                                                <div className='colFlex' style={{ maxHeight: divHeight, overflowY: 'scroll', flexWrap: 'wrap', alignContent: 'flex-start', marginLeft: '2vw' }}>
                                                    {includeTimes.map((row, index) => (
                                                        this.filterPassedTime(row) ?
                                                            <div key={'timeSlots' + index} className={clsx({ ['timePicker desc']: true, ['selectedTime']: row == selectedDate })} >
                                                                <span onClick={(e) => this.selectTime(row)}>{Moment(row.getTime()).format('hh:mm a')}</span>
                                                            </div>
                                                            : null
                                                    ))}</div>
                                        }
                                    </div>
                                </div>

                            </div>
                            <div onClick={(e) => this.confirm()} className='buttonText confirmButton mobile-formButtonContainer'>CONFIRM</div>
                        </div>
                    }

                </div>

        )
    }
}
Scheduler.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default withRouter(Scheduler);
